import { render, staticRenderFns } from "./modules.vue?vue&type=template&id=27da3e3e&scoped=true"
import script from "./modules.vue?vue&type=script&lang=js"
export * from "./modules.vue?vue&type=script&lang=js"
import style0 from "./modules.vue?vue&type=style&index=0&id=27da3e3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27da3e3e",
  null
  
)

export default component.exports